import Plyr from 'plyr';
export const intersectionPlyrVideosObserver = new IntersectionObserver((entries, observer) => {
    // Если intersectionRatio равен 0, цель вне зоны видимости
    // и нам не нужно ничего делать
    entries.forEach(entry => {
        if (entry.intersectionRatio <= 0) {
            entry.target.pause();
        } else {
            entry.target.play();
        }
    });
});

if(document.querySelector('video.video-js')) {

    const lazyVideos = [].slice.call(document.querySelectorAll('video.video-js'));

    window.plyrPlayers = window.plyrPlayers || [];

    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove('mw-mh')
                    setTimeout(() => {
                        video.target.play();
                    }, 250)// задержка к тому моменту пока слайд остановиться после пролистывания
                    video.target.addEventListener('canplay', () => {
                        if(video.target.paused) {
                            video.target.play();
                        }
                    })
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach((el) => {
            const plyrPlayer = new Plyr(el, {
                debug: false,
                volume: 0,
                autoplay: true,
                muted: true,
                controls: el.dataset.withoutFullscreen === 'true' ? false : ['fullscreen'],
                fullscreen: {
                    enabled: true,
                    fallback: true,
                    iosNative: true,
                    container: null
                }
            })
            //window.plyrPlayers.push(plyrPlayer);
            lazyVideoObserver.observe(el);
        })
    }

    /*window.plyrPlayers.forEach((el) => {
        intersectionPlyrVideosObserver.observe(el.media);
    });*/
}

setInterval(() => {
    document.querySelectorAll('video.video-js').forEach((el) => {
        if(el.paused) {
            el.play();
            el.addEventListener('canplay', () => {
                if(el.paused) {
                    el.play();
                }
            })
        }
    })
}, 1000)

setInterval(() => {
    document.querySelectorAll('.plyr__video-wrapper').forEach((el) => {
        let video = el.querySelector('video.video-js')
        let poster = el.querySelector('.plyr__poster')

        if(video && poster && video.fullLodaded !== true && video.currentTime > 0.01) {
            video.fullLodaded = true
            poster.classList.add('hide');
        }
    })
}, 50)